var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.name)?_c('div',[(_vm.app === 'admin')?_c('v-admin-base'):(_vm.app === 'organisation')?_c('v-organisation-base'):_c('v-reviewer-base')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }